// config.js
export default {
  title: "Les Vignobles Champenois",
  infoLayers: [
    {
      layername: "lieux_dits_fill",
      template: "<p><strong>Lieux-dit: </strong> {{nom}}</p>"
    },
    {
      layername: "communes_fill",
      template: "<p><strong>Commune: </strong> {{nom}}</p>"
    },
    {
      layername: "communes_fill",
      template: "<p><strong>Commune: </strong> {{nom}}</p>"
    },
    {
      layername: "aires_fill",
      template: "<p><strong>Region: </strong> {{aire}}</p>"
    },
    {
      layername: "soil_fill",
      template: "<p><strong>Type de sol: </strong> {{ger_nom}}</p>"
    },
    {
      layername: "altitude_fill",
      template: "<p><strong>Altitude: </strong> {{label}}</p>"
    },
    {
      layername: "pente_fill",
      template: "<p><strong>Pente (%): </strong> {{label}}</p>"
    },
    {
      layername: "exposition_fill",
      template: "<p><strong>Exposition: </strong> {{label}}</p>"
    }
  ],
  hoverLayers: [
    {layername: "parcelles_fill"}
  ],
  style: {
    "version": 8,
    "glyphs":"https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf",
    "sources": {
      "basemap": {
        "type": "vector",
        "url": "https://pub-42ba8c6e99cf493a9cd3d502808d3d3b.r2.dev/vignobles/champagne/layers.pmtiles",
        "attribution": "© <a href='https://openstreetmap.org/copyright'>OpenStreetMap</a>; © <a href='https://www.data.gouv.fr/fr/datasets/cadastre/'>Cadastre - Etalab</a>"
      }
    },
    "layers": [
      {
        "id": "back", 
        "type": "background", 
        "layout": {"visibility": "none"}
      },
      {
        "id": "aoc_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "aoc",
        "paint": {
          "fill-color": "#FFD700",
          "fill-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            8, 0.2,
            11, 0
          ]
        },
        "maxzoom": 11
      },
      {
        "id": "soil_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "soil",
        "paint": {"fill-color": "#ffffff", "fill-opacity": 0}
      },
      {
        "id": "altitude_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "altitude",
        "paint": {"fill-color": "#ffffff", "fill-opacity": 0}
      },
      {
        "id": "pente_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "pente",
        "paint": {"fill-color": "#ffffff", "fill-opacity": 0}
      },
      {
        "id": "exposition_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "exposition",
        "paint": {"fill-color": "#ffffff", "fill-opacity": 0}
      },
      {
        "id": "residential-border",
        "type": "line",
        "source": "basemap",
        "source-layer": "residential",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "black", "line-width": 1, "line-opacity": 1}
      },
      {
        "id": "residential-fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "residential",
        "paint": {"fill-color": "rgba(200, 200, 200, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "allotments_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "allotments",
        "paint": {"fill-color": "rgba(80, 80, 80, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "allotments_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "allotments",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 1}
      },
      {
        "id": "amenity_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "amenity",
        "paint": {"fill-color": "rgba(30, 30, 30, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "amenity_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "amenity",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 0.3}
      },
      {
        "id": "farmland_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "farmland",
        "paint": {
          "fill-color": "rgba(230, 230, 230, 1)",
          "fill-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            12, 0.2,
            13, 0.5
          ]
        }
      },
      {
        "id": "farmland_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "farmland",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 0.2}
      },
      {
        "id": "cemetery_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "cemetery",
        "paint": {"fill-color": "rgba(47, 47, 47, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "cemetery_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "cemetery",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 0.3}
      },
      {
        "id": "industrial_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "industrial",
        "paint": {"fill-color": "rgba(65, 65, 65, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "industrial_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "industrial",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 1}
      },
      {
        "id": "leisure_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "leisure",
        "paint": {"fill-color": "rgba(96, 96, 96, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "leisure_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "leisure",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 0.3}
      },
      {
        "id": "meadow_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "meadow",
        "paint": {"fill-color": "rgba(173, 173, 173, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "meadow_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "meadow",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 1}
      },
      {
        "id": "orchard_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "orchard",
        "paint": {"fill-color": "rgba(222, 222, 222, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "orchard_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "orchard",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 1}
      },
      {
        "id": "retail_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "retail",
        "paint": {"fill-color": "rgba(158, 158, 158, 1)", "fill-opacity": 0.5}
      },
      {
        "id": "retail_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "retail",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 0.3}
      },
      {
        "id": "water_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "water",
        "paint": {
          "fill-color": "rgba(0, 0, 0, 1)",
          "fill-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            10, 0,
            14, 1
          ]
        }
      },
      {
        "id": "wood_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "wood",
        "paint": {
          "fill-color": [
            "match",
            ["get", "leaf_type"],
            "needleleaved",
            "#909090",
            "broadleaved",
            "#282828",
            "mixed",
            "#202020",
            "#404040"
          ],
          "fill-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            12, 0,
            13, 0.6
          ]
        }
      },
      {
        "id": "wood_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "wood",
        "layout": {"line-join": "bevel"},
        "paint": {"line-color": "#232323", "line-width": 1}
      },
      {
        "id": "vineyard-fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "vineyard",
        "paint": {
          "fill-color": "rgba(255, 220, 65, 1)",
          "fill-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            12, 0,
            13, 0.5
          ]
        }
      },
      {
        "id": "lieux_dits_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "lieux_dits",
        "paint": {
          "fill-color": "#FFC300",
          "fill-opacity": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            0.3,
            0
          ]
        }
      },
      {
        "id": "parcelles_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "parcelles",
        "paint": {"fill-color": "#ffffff", "fill-opacity": 0}
      },
      {
        "id": "parcelles-border",
        "type": "line",
        "source": "basemap",
        "source-layer": "parcelles",
        "paint": {
          "line-color": "#323131",
          "line-width": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            2,
            0.1
          ]
        }
      },
      {
        "id": "building-fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "building",
        "paint": {
          "fill-color": "#000000",
          "fill-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            14, 0,
            15, 1
          ]
        }
      },
      {
        "id": "highway-line",
        "type": "line",
        "source": "basemap",
        "source-layer": "highway",
        "paint": {
          "line-color": "black",
          "line-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            12, 0,
            14, 1
          ],
          "line-width": [
            "match",
            ["get", "highway"],
            "tertiary",
            0.3,
            "primary",
            3,
            "secondary",
            2,
            "residential",
            0.3,
            0.3
          ]
        }
      },
      {
        "id": "railway-line",
        "type": "line",
        "source": "basemap",
        "source-layer": "railway",
        "paint": {"line-color": "black", "line-opacity": 1, "line-width": 1}
      },
      {
        "id": "lieux_dits_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "lieux_dits",
        "layout": {"line-join": "bevel"},
        "paint": {
          "line-color": "#000000",
          "line-width": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            2.5,
            0
          ]
        }
      },
      {
        "id": "communes_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "communes",
        "paint": {"fill-opacity": 0}
      },
      {
        "id": "aires_fill",
        "type": "fill",
        "source": "basemap",
        "source-layer": "aires",
        "paint": {
          "fill-color": [
            "match",
            ["get", "region"],
            "Côte des Bars", "#c39bd3",
            "Montagne de Reims", "#f8c471",
            "Côte des Blancs", "#abebc6",
            "Vallée de la Marne", "#f1948a",
            "#e0e0e0"
          ],
          "fill-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            8, 0.5,
            12, 0
          ]
        }
      },
      {
        "id": "aires_border",
        "type": "line",
        "source": "basemap",
        "source-layer": "aires",
        "layout": {"line-join": "bevel"},
        "paint": {
          "line-color": "#000000",
          "line-width": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            3,
            1
          ]
        },
        "maxzoom": 12
      },
      {
        "id": "commmunes-border",
        "type": "line",
        "source": "basemap",
        "source-layer": "communes",
        "layout": {"line-join": "bevel"},
        "paint": {
          "line-color": "#000000",
          "line-width": [
            "case",
            ["boolean", ["feature-state", "hover"], false],
            2,
            0.1
          ]
        }
      },
      {
        "id": "communes_label",
        "type": "symbol",
        "source": "basemap",
        "source-layer": "communes",
        "layout": {
          "text-field": ["get", "nom"],
          "text-size": 12,
          "text-anchor": "center",
          "symbol-placement": "point",
          "text-allow-overlap": false
        },
        "paint": {
          "text-color": "#000000"
        },
        "minzoom": 10
      },
      {
        "id": "aires_label",
        "type": "symbol",
        "source": "basemap",
        "source-layer": "aires",
        "layout": {
          "text-field": ["get", "aire"],
          "text-size": 12,
          "text-anchor": "center",
          "symbol-placement": "point",
          "text-allow-overlap": false
        },
        "paint": {
          "text-color": "#000000"
        },
        "minzoom": 8.5,
        "maxzoom": 11
      }
    ]
  }
};
